import React from 'react';
export const SpaceContext = /*#__PURE__*/React.createContext({
  latestIndex: 0
});
export const SpaceContextProvider = SpaceContext.Provider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/space/context.js
// module id = 452
// module chunks = 0